import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes/routes";
import AlertMessage from "./components/common/alertMessage";
import { connect } from "react-redux";
import * as _ from "lodash"
function App(props) {
  return (
    <>
      <BrowserRouter>
        <Routes></Routes>
      </BrowserRouter>
      {
      !_.isEmpty(props.alerts) &&
      <AlertMessage
        className="alert-message"
        type={props.alerts.type}
        messageHeader={props.alerts.messageHeader}
        messageBody={props.alerts.messageBody}
      />
      }
    </>
  );
}

const mapStateToProps = ({ alerts }) => {
  return {
    alerts,
  };
};

export default connect(mapStateToProps)(App);
